
const Formulas = () => {
  const formulas = [
    {
      title: "Formule Cocktail Dînatoire et Déjeunatoire",
      price: "69€",
      priceDetail: "par personne",
      minGuests: "À partir de 200 personnes",
      features: [
        "16 pièces cocktails salées",
        "Une animation culinaire salée",
        "Boissons non alcoolisées à volonté",
        "Buffet dessert"
      ],
      image: "https://readdy.ai/api/search-image?query=elegant%20cocktail%20reception%20with%20sophisticated%20canap%C3%A9s%20and%20appetizers%20on%20silver%20platters%2C%20professional%20catering%20service%2C%20luxurious%20presentation%20with%20garnishes%2C%20modern%20upscale%20event%20setting%2C%20warm%20ambient%20lighting%2C%20refined%20culinary%20artistry&width=400&height=300&seq=cocktail-formula&orientation=landscape"
    },
    {
      title: "Formule Bords de Marne",
      price: "79€",
      priceDetail: "par personne",
      minGuests: "À partir de 150 personnes",
      features: [
        "1 cocktail d'accueil (6 pièces/personne) ainsi qu'une entrée servie à l'assiette",
        "Ou l'entrée sous forme de cocktail (10 pièces/personne)",
        "Boissons non alcoolisées à volonté",
        "1 plat plus 2 accompagnements au choix",
        "Dessert à l'assiette ou Buffet Dessert",
        "Café et thé"
      ],
      image: "https://readdy.ai/api/search-image?query=elegant%20plated%20dinner%20service%20with%20gourmet%20main%20course%20and%20side%20dishes%2C%20fine%20dining%20presentation%2C%20professional%20catering%20setup%2C%20sophisticated%20table%20setting%2C%20warm%20restaurant%20lighting%2C%20culinary%20excellence%20and%20artistry&width=400&height=300&seq=bords-marne-formula&orientation=landscape"
    },
    {
      title: "Formule Prestige",
      price: "99€",
      priceDetail: "par personne",
      minGuests: "À partir de 100 personnes",
      features: [
        "1 cocktail d'accueil (8 pièces/personne) ainsi qu'une entrée servie à l'assiette",
        "Ou l'entrée sous forme de cocktail (12 pièces/personne)",
        "Boissons non alcoolisées à volonté",
        "1 plat plus 2 accompagnements au choix",
        "Assortiment de fromages sous forme de buffet",
        "Dessert à l'assiette ou buffet dessert",
        "Café et thé"
      ],
      image: "https://readdy.ai/api/search-image?query=luxury%20gourmet%20dining%20experience%20with%20premium%20plated%20dishes%2C%20artisanal%20cheese%20buffet%2C%20elegant%20dessert%20presentation%2C%20high-end%20catering%20service%2C%20sophisticated%20culinary%20artistry%2C%20refined%20restaurant%20ambiance%20with%20warm%20lighting&width=400&height=300&seq=prestige-formula&orientation=landscape"
    }
  ];

  return (
    <section id="formules" className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Titre */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-300 mb-8" style={{ fontFamily: 'Alice, serif' }}>
              Nos Formules
            </h2>
            
            {/* Ligne décorative */}
            <div className="flex items-center justify-center mb-8">
              <div className="w-24 h-px bg-gray-300"></div>
              <div className="w-4 h-4 bg-gray-300 rounded-full mx-6 rotate-45"></div>
              <div className="w-24 h-px bg-gray-300"></div>
            </div>

            <p className="text-gray-300 text-lg max-w-2xl mx-auto">
              Découvrez nos formules sur mesure, conçues pour sublimer vos événements 
              avec l'excellence culinaire française.
            </p>
          </div>

          {/* Grille des formules */}
          <div className="grid lg:grid-cols-3 gap-8">
            {formulas.map((formula, index) => (
              <div 
                key={index}
                className="bg-gradient-to-b from-gray-800/50 to-gray-900/50 rounded-2xl p-8 border border-gray-700/30 hover:border-gray-600/50 transition-all duration-300 transform hover:scale-105 flex flex-col h-full"
              >
                {/* Image */}
                <div className="relative mb-6 overflow-hidden rounded-lg">
                  <img
                    src={formula.image}
                    alt={formula.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                </div>

                {/* Titre */}
                <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Alice, serif' }}>
                  {formula.title}
                </h3>

                {/* Prix */}
                <div className="text-center mb-6">
                  <div className="text-4xl font-bold text-gray-300 mb-2">
                    {formula.price}
                  </div>
                  <div className="text-gray-400 text-sm mb-2">
                    {formula.priceDetail}
                  </div>
                  <div className="text-gray-300 text-sm font-semibold bg-gray-700/30 rounded-full px-4 py-2 inline-block">
                    {formula.minGuests}
                  </div>
                </div>

                {/* Caractéristiques */}
                <div className="space-y-3 flex-grow">
                  {formula.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-start">
                      <div className="w-2 h-2 bg-gray-300 rounded-full mr-3 mt-2 flex-shrink-0"></div>
                      <span className="text-gray-300 text-sm leading-relaxed">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Note informative */}
          <div className="text-center mt-12">
            <p className="text-gray-400 text-sm">
              Toutes nos formules sont personnalisables selon vos besoins et préférences. 
              Contactez-nous pour un devis sur mesure.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Formulas;
